// list of all store getters
import Vue from 'vue'

export const Getters = {
  // auth
  IS_AUTHENTICATED: 'isAuthenticated',
  AUTH_USER: 'authUser',
  AUTH_LOADING: 'authLoading',
  // app
  APP_INITIALIZED: 'appInitialized',
  APP_HAS_ERRORS: 'appHasErrors',
  APP_LOADING: 'appLoading',
  APP_TEAMS: 'appTeamsData',
  APP_CURRENT_TEAM: 'appCurrentTeam',
  APP_LAYOUTS: 'appLayouts',
  // alert
  ALERT: 'alert',
  ALERT_VISIBLE: 'alertVisible',
  // variables
  VARIABLES_ALL: 'variablesAll',
  VARIABLES_LOADING: 'variablesLoading',
  VARIABLES_BY_CATEGORIES: 'variablesByCategories'
}

declare module 'vue/types/vue' {
  interface Vue {
    $storeGetters: typeof Getters;
  }
}

// noinspection JSUnusedGlobalSymbols
Vue.prototype.$storeGetters = Getters
